module.exports = __webpack_public_path__ + "img/globulo-stars.b8fedc16.png";